module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "tdp.9184e0fb.png";